import PropTypes from "prop-types";
import Text from "components/Common/Text";
import { formatValue, matchPlayColorScheme } from "./MatchPlayCard";

export function WaysCard({ type, value }) {
  const waysCardsTypes = {
    0: "Completed",
    1: "Playing",
    2: "Projected",
  };

  const emoji = {
    0: "👋",
    1: "🏌️‍♀️",
    2: "⛳️",
  };

  return (
    <div
      style={{
        backgroundColor: "#FFFF",
        height: 134,
        minWidth: 112,
        borderRadius: 10,
        marginRight: 8,
      }}
    >
      <Text as="H1" ta="center" style={{ paddingTop: 12 }}>
        {emoji[type]}
      </Text>
      <Text as="C1" bold ta="center" style={{ color: "#5C6363" }}>
        {waysCardsTypes[type]}
      </Text>
      <Text
        as="H1"
        bold
        ta="center"
        style={{ color: matchPlayColorScheme(value).color, fontWeight: "700" }}
      >
        {formatValue({ payouts: true, value })}
      </Text>
      <Text as="C1" bold ta="center" style={{ color: "#5C6363" }}>
        Ways
      </Text>
    </div>
  );
}
WaysCard.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};
